import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class SyncService {

	private resetUrl = `${environment.crmmigrationUrl}/api/reset`;

	constructor(private readonly http: HttpClient) {
	}

	getDatabaseOverviewByConnectionString(connectionString: string): Promise<Record<string, string[]>> {
		return firstValueFrom(this.http.get<Record<string, string[]>>(`${this.resetUrl}/get-database-overview?connectionString=${encodeURIComponent(connectionString)}`));
	}

	getDatabaseOverview(targetDatabase: string): Promise<Record<string, string[]>> {
		return firstValueFrom(this.http.get<Record<string, string[]>>(`${this.resetUrl}/get-database-overview?targetDatabase=${targetDatabase}`));
	}

	clearAndCopyData(copyData: CopyDataDto): Promise<void> {
		return firstValueFrom(this.http.post<void>(`${this.resetUrl}/clear-and-copy-data`, copyData));
	}

}

export class CopyDataDto {
	public connectionString: string = '';
	public targetDatabase: string = '';
	public copyHistoricalData: boolean = false;
	public properties: CopyDataProperty[] = [];
}

export class CopyDataProperty {
	public sourceTable: string = '';
	public sourceProperty: string = '';
	public targetTable: string = '';
	public targetProperty: string = '';

	constructor(targetTable: string = '', targetProperty: string = '') {
		this.targetTable = targetTable;
		this.targetProperty = targetProperty;
	}
}
